import { FC } from 'react';
import { Engine, Policy } from '@agilelab/plugin-wb-governance-common';
import { Box } from '@material-ui/core';
import { PolicyCueScriptEditor } from '../../../PolicyDetail';
import { PolicyWittyGovernanceAgentEditor } from '../../../PolicyDetail/PolicyWittyGovernanceAgentEditor';
import { GovernanceTestOverviewPolicyInfo } from './GovernanceTestOverviewPolicyInfo';

interface Props {
  policy: Policy;
  onUpdate: (code?: string) => void;
  editable: boolean;
  saving: boolean;
  handleSave: () => void;
  showSaveButton: boolean;
}

export const GovernanceTestOverviewPolicySimple: FC<Props> = props => {
  return (
    <>
      <GovernanceTestOverviewPolicyInfo {...props} />

      {props.policy.engine === Engine.Cue && (
        <Box mt={2}>
          <PolicyCueScriptEditor
            cueScript={props.policy.cueSpecific.cueScript}
            {...props}
          />
        </Box>
      )}
      {props.policy.engine === Engine.GovernanceAgent && (
        <Box mt={2}>
          <PolicyWittyGovernanceAgentEditor
            policyContent={props.policy.governanceAgentSpec.prompt}
            {...props}
          />
        </Box>
      )}
    </>
  );
};
